import styled from 'styled-components'
import { Row } from 'reactstrap'

export const StyledRow = styled(Row)`
  background-color: #002855;
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  button {
    margin-left: 0.5rem;
  }
`



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/LicenseHeader/component.styles.js